module.exports = __webpack_public_path__ + "static/Vinod-b8a172f5918aa7532ba7a7d65c5d7f9a.jpg";